import { ActionType } from './command-parser.model';

const INTENT_KEYWORDS: { keyword: string; intent: ActionType }[] = [
  // Multi-word placeholders (add actions)
  { keyword: '__PASTA_IN_BIANCO__', intent: 'pasta-in-bianco' },
  { keyword: '__PASTA_BIANCO__', intent: 'pasta-in-bianco' },
  { keyword: '__PASTA_BIANCA__', intent: 'pasta-in-bianco' },
  { keyword: '__NON_PRESENTE__', intent: 'assenza' },
  // Single-word keywords (add actions)
  { keyword: 'assenza', intent: 'assenza' },
  { keyword: 'assente', intent: 'assenza' },
  { keyword: 'malato', intent: 'assenza' },
  { keyword: 'malattia', intent: 'assenza' },
  { keyword: 'mancanza', intent: 'assenza' },
  { keyword: 'giustifica', intent: 'assenza' },
  { keyword: 'pasta', intent: 'pasta-in-bianco' },
  { keyword: 'bianco', intent: 'pasta-in-bianco' },
  { keyword: 'bianca', intent: 'pasta-in-bianco' },
  // Payment keywords
  { keyword: 'ricarica', intent: 'genera-pagamento' },
  { keyword: 'ricariche', intent: 'genera-pagamento' },
  { keyword: 'pagamento', intent: 'genera-pagamento' },
  { keyword: 'pagamenti', intent: 'genera-pagamento' },
  { keyword: 'bollettino', intent: 'genera-pagamento' },
];

export interface IntentMatch {
  intent: ActionType;
  matchedToken: string;
}

/**
 * Matches intent from tokens. If detectedRemoveIntent is provided (from the
 * tokenizer's verb+object pattern matcher), it takes priority and we find its
 * placeholder token.
 */
export function matchIntent(
  tokens: string[],
  childNames: string[],
  detectedRemoveIntent?: ActionType | null
): IntentMatch | null {
  // If the tokenizer already detected a remove intent, find the placeholder
  if (detectedRemoveIntent) {
    const placeholder = tokens.find(t => t.startsWith('__REMOVE_'));
    if (placeholder) {
      return { intent: detectedRemoveIntent, matchedToken: placeholder };
    }
  }

  const childNamesLower = childNames.map(n => n.toLowerCase());

  for (const token of tokens) {
    const entry = INTENT_KEYWORDS.find(k => k.keyword === token);
    if (entry) {
      // If token could also be a child name, prioritize child (design decision 11)
      if (childNamesLower.includes(token) && !token.startsWith('__')) {
        continue;
      }
      return { intent: entry.intent, matchedToken: token };
    }
  }
  return null;
}
